import React, { useEffect, useState } from "react";
import "./ChristmasEvent.css";

const christmasImages = [
  { id: 1, src: "/events/christmas1.png", alt: "Christmas Celebration 1" },
  { id: 2, src: "/events/christmas2.png", alt: "Christmas Celebration 2" },
  { id: 3, src: "/events/christmas3.png", alt: "Christmas Celebration 3" },
  { id: 4, src: "/events/christmas4.png", alt: "Christmas Celebration 4" },
  { id: 5, src: "/events/christmas5.png", alt: "Christmas Celebration 1" },
  { id: 6, src: "/events/christmas6.png", alt: "Christmas Celebration 2" },
  { id: 7, src: "/events/christmas7.png", alt: "Christmas Celebration 3" },
  { id: 8, src: "/events/christmas8.png", alt: "Christmas Celebration 4" },
  { id: 9, src: "/events/christmas9.png", alt: "Christmas Celebration 1" },
  { id: 10, src: "/events/christmas10.png", alt: "Christmas Celebration 2" },
  { id: 11, src: "/events/christmas11.png", alt: "Christmas Celebration 3" },
  { id: 12, src: "/events/christmas12.png", alt: "Christmas Celebration 4" },
  { id: 13, src: "/events/christmas13.png", alt: "Christmas Celebration 1" },
  { id: 14, src: "/events/christmas14.png", alt: "Christmas Celebration 2" },
  { id: 15, src: "/events/christmas15.png", alt: "Christmas Celebration 3" },
  { id: 16, src: "/events/christmas16.png", alt: "Christmas Celebration 4" },
  { id: 17, src: "/events/christmas17.png", alt: "Christmas Celebration 1" },
  { id: 18, src: "/events/christmas18.png", alt: "Christmas Celebration 2" },
  { id: 19, src: "/events/christmas19.png", alt: "Christmas Celebration 3" },
];

export default function ChristmasEvent() {
  useEffect(() => {
    document.title = "Christmas Celebration | Gifted Child Therapy";
  }, []);

  const [selectedImage, setSelectedImage] = useState(null);
  const [zoomLevel, setZoomLevel] = useState(1);

  const openImage = (image) => {
    setSelectedImage(image);
    setZoomLevel(1);
    document.body.style.overflow = "hidden"; // disable background scroll
  };

  const closeImage = () => {
    setSelectedImage(null);
    document.body.style.overflow = "auto";
  };

  const handleZoom = (e) => {
    e.preventDefault();
    const zoom = zoomLevel + e.deltaY * -0.001; // smooth zoom
    if (zoom > 0.8 && zoom < 5) setZoomLevel(zoom);
  };

  return (
    <div className="christmas-page">
      {/* Page Header */}
      <div className="christmas-header">
        <h1>🎄 Christmas Celebration</h1>
        <p>
          A joyful and memorable Christmas celebration filled with smiles,
          laughter, and meaningful experiences for our children.
        </p>
      </div>

      {/* Event Content */}
      <section className="christmas-content section">
        <div className="section-content">
          <h2 className="section-heading">Celebrating Joy & Togetherness</h2>

          <p className="section-text">
            Our Christmas celebration was a heart-warming event where children
            experienced the true spirit of the season through fun-filled
            activities, creative play, and festive interactions.
          </p>

          <p className="section-text">
            The children enthusiastically participated in decorating the space,
            singing Christmas songs, engaging in group games, and enjoying
            joyful moments with peers and therapists.
          </p>

          <p className="section-text">
            Events like these help nurture{" "}
            <strong>social interaction</strong>,{" "}
            <strong>emotional expression</strong>, and a strong sense of{" "}
            <strong>belonging</strong>, making learning joyful and meaningful.
          </p>
        </div>
      </section>

      {/* Image Gallery Grid */}
      <section className="christmas-gallery">
        <h2 className="section-heading center">
          Moments from the Celebration
        </h2>

        <div className="gallery-grid">
          {christmasImages.map((img) => (
            <div key={img.id} className="gallery-card">
              <img
                src={img.src}
                alt={img.alt}
                className="gallery-img"
                onClick={() => openImage(img)}
              />
            </div>
          ))}
        </div>
      </section>

      {/* Fullscreen Modal */}
      {selectedImage && (
        <div className="image-modal" onClick={closeImage}>
          <span className="close-btn" onClick={closeImage}>
            ✕
          </span>

          <img
            src={selectedImage.src}
            alt={selectedImage.alt}
            className="modal-img"
            style={{ transform: `scale(${zoomLevel})` }}
            onWheel={handleZoom}
            onClick={(e) => e.stopPropagation()} // prevent close on clicking image
          />
        </div>
      )}
    </div>
  );
}
